import React, { useState, useEffect } from 'react'
import { iconBtn, iconBtnDanger } from '../../components/ui/iconButton';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Badge from '../../components/Badge';
import Table from '../../components/Table';
import PageHeader from '../../components/PageHeader';
import DashBoardSupport from './DashBoardSupport/DashBoardSupport';
import { FaTicketAlt } from 'react-icons/fa';
import { ticketService } from '../../services/ticketService';
import { formatdateWithTime } from '../../utils/helpers';

const Support = () => {
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTickets = async () => {
      const { data, error } = await ticketService.getAll();
      if (!error) {
        setTickets(data);
      }
    };
    fetchTickets();
  }, []);


  const columns = [
    {
      key: 'folio',
      title: 'Folio',
      sortable: true,
    },
    {
      key: 'type',
      title: 'Tipo',
      sortable: true,
      render: (value, item) => <Badge type="type" value={item.type} />
    },
    {
      key: 'severity',
      title: 'Gravedad',
      sortable: true,
      render: (value, item) => <Badge type="severity" value={item.severity} />
    },
    {
      key: 'project_id',
      title: 'Agente',
      sortable: true,
      render: (value, item) => item.project_id.name
    },
    {
      key: 'created_at',
      title: 'Reportado',
      sortable: true,
      render: (value, item) => formatdateWithTime(item.created_at)
    },
    {
      key: 'closed_date',
      title: 'Fecha de cierre',
      sortable: true,
      render: (value, item) => item.closed_date ? formatdateWithTime(value) : ' Sin cerrar'
    },
    {
      key: 'status',
      title: 'Estado',
      sortable: true,
      render: (value, item) => <Badge type="status" value={item.status} />
    },
    {
      key: 'actions',
      title: 'Acciones',
      sortable: false,
      render: (_, item) => (
        <div className="flex space-x-2">
          <button
            onClick={() => viewTicket(item)} 
            className={iconBtn}
            title="Detalles del Ticket"
          >
            <FaTicketAlt />
          </button>
        </div>
      )
    },
  ];

  // Opciones de la tabla
  const tableOptions = {
    pagination: true,
    pageSize: 5,
    pageSizeOptions: [5, 10, 20],
    showSearch: true,
    searchPlaceholder: 'Buscar tickets por folio...',
    emptyMessage: 'No hay tickets disponibles',
  };

  const viewTicket = (ticket) => {
    navigate('/support/ticket', { state: { ticket } });
  };

  return (
    <div>
      <PageHeader title="Soporte" subtitle="Tickets y métricas del equipo de soporte" />
      <DashBoardSupport />
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.16,1,0.3,1], delay: 0.1 }} className="mt-5"
      >
        <Table data={tickets} columns={columns} options={tableOptions} />
      </motion.div>
    </div>
  )
}

export default Support
